import {z} from 'zod'
import {buildPageSchemaForTemplate} from '@github-ui/swp-core/schemas/contentful/contentTypes/containerPage'
import {TemplateArticleSchema, TemplateArticleTruncatedSchema} from './templateResourcesArticle'
import {TemplateWhitepaperIndexSchema} from './templateWhitepaperIndex'
import {TemplateWhitepaperTruncatedSchema} from './templateWhitepaper'

const ArticlePageSchema = buildPageSchemaForTemplate(TemplateArticleSchema)
const CategoryPageSchema = buildPageSchemaForTemplate(TemplateArticleTruncatedSchema)

const WhitepaperIndexSchema = buildPageSchemaForTemplate(TemplateWhitepaperIndexSchema)
const WhitepaperTruncatedSchema = buildPageSchemaForTemplate(TemplateWhitepaperTruncatedSchema)

export type ArticlePageContainer = z.infer<typeof ArticlePageSchema>
export type CategoryPageContainer = z.infer<typeof CategoryPageSchema>

export function toArticlePage(item: unknown): ArticlePageContainer {
  return ArticlePageSchema.parse(item)
}

export function toCategoryPage(items: unknown[]): CategoryPageContainer[] {
  return items.map(item => CategoryPageSchema.parse(item))
}

export type WhitepaperHomepageContainer = z.infer<typeof WhitepaperIndexSchema>
export type WhitepaperDetailTruncatedContainer = z.infer<typeof WhitepaperTruncatedSchema>

export function toWhitepaperIndex(item: unknown): WhitepaperHomepageContainer {
  return WhitepaperIndexSchema.parse(item)
}

export function toTruncatedWhitepaper(item: unknown): WhitepaperDetailTruncatedContainer {
  return WhitepaperTruncatedSchema.parse(item)
}

const WhitepaperContainerPageSchema = z.union([WhitepaperIndexSchema, WhitepaperTruncatedSchema])

export type WhitepaperContainerPage = z.infer<typeof WhitepaperContainerPageSchema>
export function toWhitepaperContainerPage(item: unknown): WhitepaperContainerPage {
  return WhitepaperContainerPageSchema.parse(item)
}
